var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseCalenderDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar (13) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.06543 9.18262H17.5422",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4092 11.917H14.4155",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3037 11.917H11.31",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.19043 11.917H8.19673",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.4092 14.637H14.4155",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.3037 14.637H11.31",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.19043 14.637H8.19673",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.1309 4V6.3037",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.47607 4V6.3037",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2668 5.10547H8.33967C6.28399 5.10547 5 6.25062 5 8.35559V14.6903C5 16.8284 6.28399 18 8.33967 18H14.2603C16.3225 18 17.6 16.8483 17.6 14.7433V8.35559C17.6065 6.25062 16.329 5.10547 14.2668 5.10547Z",
    stroke: "#E4E4E4",
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseCalenderDarkIcon);
export default __webpack_public_path__ + "static/media/course-calender-dark-icon.8e4c91bb48df2ea0a99887e55ae41091.svg";
export { ForwardRef as ReactComponent };